import { useRef, useState } from 'react'
import config from './collision.config'
import { Button, message, Popconfirm, TreeSelect } from 'antd'

import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'

import CheckThePhone from '@/components/CheckThePhone'
import { apiData2Table } from '@/utils/data.ts'
import {getCollisionPage, getDispatchMnrList} from "@/services/saleOpServices.ts";
import {getBusinessLines, getChannels} from "@/services/getUsers.ts";
import {getChannelCategoryTree} from "@/services/channelManagement.ts";
import {getAnchorFn} from "@/pages/clueManage/utils.tsx";
import {httpOrgList} from "@/services/homeService.ts";
import {getRegionLists} from "@/services/customerServices.ts";

function Collision() {
  const listRef = useRef<any>()
  const [loading, setLoading] = useState<boolean>(false)

  const [businessLineMap, setBusinessLineMap] = useState<Record<string, string>>({})
  const getSelection = () => {
    return new Promise(resolve => {
      Promise.all([
        getBusinessLines(),
        getChannels(),
        httpOrgList(),
        getAnchorFn('ADVERT'),
        getRegionLists(),
      ]).then(resp => {
        const businessLines = resp[0]
        const tempBusinessLineMap = {}
        businessLines.forEach(item => {
          tempBusinessLineMap[item.code] = item.name
        })
        setBusinessLineMap(tempBusinessLineMap)

        resolve({
          businessLines,
          channels: resp[1],
          companyList: resp[2],
          anchor: resp[3],
          cityArea: resp[4],
        })
      })
    })
  }

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        getCollisionPage({params: {pageId: current, pageSize}, data: {...query}})
            .then(data => resolve(apiData2Table(data)))
            .finally(() => {
              setLoading(false)
            })
      } catch {
        reject({ success: false })
        setLoading(false)
      }
    })
  }

  const dispatch = ({ selectedRowKeys: clueIds }: { selectedRowKeys: number[] }) => {
    if (!clueIds.length) return message.warning('请先选择至少一条数据')
    setLoading(true)
  }

  const edit = (obj: any) => {
  }

  const filterOption = (input: string, option: any) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

  const extension = {
    request: { fetchList, getSelection },
    events: { filterOption },
    customRender: {
      checkPhone(text: any, record: any, index: any) {
        return (
          <CheckThePhone
              clueId={record.id}
              initValue={text}
              auth="errorListViewPhone"/>
        )
      },
      businessLineRender(val: string) {
        return businessLineMap && businessLineMap[val] ? businessLineMap[val] : val
      },
      dispatch(record: any) {
        // const isBtnObj = processButtonData({ arr: authArr, stateCode: record?.stateCode });
        return (
          <Popconfirm
            disabled={loading}
            title="确认继续派单吗？"
            onConfirm={() => dispatch(record)}
          >
            <Button disabled={loading} type="primary">
              继续派单
            </Button>
          </Popconfirm>
        )
      },
      operationCell(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              onClick={() => {
                edit({ ...record, exception: true })
              }}
            // datareskey="EditBizDetailButton"
            >
              编辑
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return <SLowcodeList searchMode={'group'} config={{ ...config }} ref={listRef} {...extension} />
}

export default Collision
